import { PAGE_TYPES } from '@utils/pageType';
import { DEFAULT_APP_ROUTE } from './reducer';
/**
 * The route of the app that owns the current page. Replaces the MST `userSettings.app` view —
 * `appRoute` is derived from the parser result, so it already accounts for platform and page kind.
 */
export const selectAppRoute = (state) => state.app.appRoute || DEFAULT_APP_ROUTE;
/** Mirrors MST ContextViews.isContact. */
export const selectIsContactPage = (state) => state.app.pageType === PAGE_TYPES.PROFILE;
/** Mirrors MST ContextViews.isBulk. */
export const selectIsBulkPage = (state) => state.app.pageType === PAGE_TYPES.BULK;
/** Mirrors MST ContextViews.isLinkedinCompany — both regular LinkedIn and Sales Navigator. */
export const selectIsLinkedinCompanyPage = (state) => state.app.pageType === PAGE_TYPES.LINKEDIN_COMPANY;
/** Mirrors MST ContextViews.isCompanyPage. */
export const selectIsCompanyPage = (state) => state.app.pageType === PAGE_TYPES.SALESFORCE_ACCOUNT ||
    state.app.pageType === PAGE_TYPES.HUBSPOT_COMPANY ||
    state.app.pageType === PAGE_TYPES.LINKEDIN_COMPANY;
/**
 * Mirrors MST ContextViews.contextTypeName. The strings key the versioned parser selectors, so
 * they must stay exactly 'bulk' | 'profile' | 'company' | 'unknown'.
 */
export const selectPageTypeName = (state) => {
    switch (state.app.pageType) {
        case PAGE_TYPES.BULK:
            return 'bulk';
        case PAGE_TYPES.PROFILE:
            return 'profile';
        case PAGE_TYPES.LINKEDIN_COMPANY:
        case PAGE_TYPES.HUBSPOT_COMPANY:
        case PAGE_TYPES.SALESFORCE_ACCOUNT:
            return 'company';
        default:
            return 'unknown';
    }
};
